import type { ApiClient } from '@revolugo/booking-api-client'
import type { ApiVersion } from '@revolugo/common/constants'
import type { IEventBus, RevolugoConfig } from '@revolugo/elements-vue3'

export const useEventBus = (): {
  elementsLoaded: Ref<boolean>
  eventBus: Ref<IEventBus>
} => {
  const events: Parameters<IEventBus['$emit']>[] = []
  let listeners: Parameters<IEventBus['$on']>[] = []

  const eventBus = ref<IEventBus>({
    $emit: (eventName, payload) => {
      events.push([eventName, payload])
    },
    // Any because type depends on the event name
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    $on: (eventName, listener: any) => {
      listeners.push([eventName, listener])
    },
    removeListener: (eventName, listener) => {
      listeners = listeners.filter(l => l[1] !== listener)
    },
  })

  const elementsLoaded = ref(false)

  window.RevolugoElements = window.RevolugoElements || {
    bookingApiClient: undefined as unknown as ApiClient<ApiVersion.V1>,
    config: undefined as unknown as RevolugoConfig,
    eventBus: undefined as unknown as IEventBus,
    ready: (cb: () => void) => {
      // eslint-disable-next-line no-underscore-dangle
      const existingCb = window.RevolugoElements?._ready
      // eslint-disable-next-line no-underscore-dangle
      window.RevolugoElements._ready = () => {
        if (existingCb) {
          existingCb()
        }
        cb()
      }
    },
  }

  window.RevolugoElements.ready(() => {
    const readyEventBus = window.RevolugoElements.eventBus

    for (const [eventName, listener] of listeners) {
      readyEventBus.$on(eventName, listener)
    }

    for (const [eventName, payload] of events) {
      readyEventBus.$emit(eventName, payload)
    }

    eventBus.value = readyEventBus
    elementsLoaded.value = true
  })

  return {
    elementsLoaded,
    eventBus,
  }
}
